import { Injectable } from '@angular/core';
import { MarcaModelo } from '@tivic-team/manager-ts/dist/fta/';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';



@Injectable()
export class MarcaModeloController{

    constructor() {}

	async get(cdMarca:number):Promise<MarcaModelo>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'fta/marcas/:cdMarca',
					environment: environment,
					pathParams: new JSONData({cdMarca: cdMarca})
				}),
			}),
			new HttpResponse(
			  new MarcaModelo()
			)
		);
		return await quark.call();
    }
    
    async find(filtros?:IFilter):Promise<Array<MarcaModelo>>{
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'fta/marcas',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<MarcaModelo>()
            )
        );
        return await quark.call();
    }

    async sync():Promise<JSON>{
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'fta/marcas/sync',
                    environment: environment
                }),
            }),
            new HttpResponse(
                new JSONData()
            )
        );
        return await quark.call();
    }

}